/**
 * Помощник соотношения сторон
 */
export class AspectRationHelper
{
    /**
     * 16:9 высота по ширине
     * @param width
     * @returns {number}
     */
    static get16x9(width)
    {
        return width / 100 * 56.25;
    }
}
